export const CATEGORIES = {
  viande: "Viande",
  poisson: "Poisson",
  legumes: "Légumes",
  plats: "Plats Préparés",
  desserts: "Desserts",
  boulangerie: "Boulangerie",
  divers: "Divers",
};

export const validateProduct = (data) => {
  const errors = {};

  // Validation du libellé
  if (!data.label?.trim()) {
    errors.label = "Le libellé est requis";
  } else if (data.label.length > 100) {
    errors.label = "Le libellé ne doit pas dépasser 100 caractères";
  }

  // Validation des unités
  if (!data.units || data.units < 1) {
    errors.units = "Le nombre d'unités doit être au moins 1";
  } else if (data.units > 100) {
    errors.units = "Le nombre d'unités ne peut pas dépasser 100";
  }

  // Validation du poids
  if (data.weight < 0) {
    errors.weight = "Le poids ne peut pas être négatif";
  } else if (data.weight > 10000) {
    // 10kg max
    errors.weight = "Le poids ne peut pas dépasser 10kg";
  }

  // Validation des portions
  if (data.portions < 1) {
    errors.portions = "Le nombre de portions doit être au moins 1";
  } else if (data.portions > 20) {
    errors.portions = "Le nombre de portions ne peut pas dépasser 20";
  }

  // Validation des dates
  const freezeDate = new Date(data.freeze_date);
  const dlc = new Date(data.dlc);
  const today = new Date();

  if (!data.freeze_date) {
    errors.freeze_date = "La date de congélation est requise";
  } else if (freezeDate > today) {
    errors.freeze_date =
      "La date de congélation ne peut pas être dans le futur";
  }

  if (!data.dlc) {
    errors.dlc = "La DLC est requise";
  } else if (dlc <= freezeDate) {
    errors.dlc = "La DLC doit être postérieure à la date de congélation";
  }

  // Validation de la catégorie
  if (!data.category || !CATEGORIES[data.category]) {
    errors.category = "La catégorie est invalide";
  }

  // Validation des détails (optionnel)
  if (data.details && data.details.length > 500) {
    errors.details = "Les détails ne doivent pas dépasser 500 caractères";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};
